/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  SECIndividual,
  SECIndividualCreate,
  SECIndividualPublic,
  SECIndividualUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    SECIndividualFromJSON,
    SECIndividualToJSON,
    SECIndividualCreateFromJSON,
    SECIndividualCreateToJSON,
    SECIndividualPublicFromJSON,
    SECIndividualPublicToJSON,
    SECIndividualUpdateFromJSON,
    SECIndividualUpdateToJSON,
} from '../models/index';

export interface CreateSecIndividualApiV1SecIndividualsPostRequest {
    sECIndividualCreate: SECIndividualCreate;
}

export interface CreateSecIndividualApiV1SecIndividualsPost0Request {
    sECIndividualCreate: SECIndividualCreate;
}

export interface DeleteSecIndividualApiV1SecIndividualsIdDeleteRequest {
    id: number;
}

export interface ReadSecIndividualApiV1SecIndividualsIdGetRequest {
    id: number;
}

export interface ReadSecIndividualPositionApiV1SecIndividualsIdPositionGetRequest {
    id: number;
    date?: Date;
}

export interface ReadSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGetRequest {
    id: number;
    limit?: number;
}

export interface ReadSecIndividualPublicApiV1SecIndividualsPublicIdGetRequest {
    id: number;
}

export interface ReadSecIndividualPublicApiV1SecIndividualsPublicIdGet0Request {
    id: number;
}

export interface ReadSecIndividualsApiV1SecIndividualsGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadSecIndividualsApiV1SecIndividualsGet0Request {
    skip?: number;
    limit?: number;
}

export interface ReadSecIndividualsPublicApiV1SecIndividualsPublicGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadSecIndividualsPublicApiV1SecIndividualsPublicGet0Request {
    skip?: number;
    limit?: number;
}

export interface UpdateSecIndividualApiV1SecIndividualsIdPutRequest {
    id: number;
    sECIndividualUpdate: SECIndividualUpdate;
}

/**
 * 
 */
export class SecIndividualsApi extends runtime.BaseAPI {

    /**
     * Create new SEC individual.
     * Create Sec Individual
     */
    async createSecIndividualApiV1SecIndividualsPostRaw(requestParameters: CreateSecIndividualApiV1SecIndividualsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['sECIndividualCreate'] == null) {
            throw new runtime.RequiredError(
                'sECIndividualCreate',
                'Required parameter "sECIndividualCreate" was null or undefined when calling createSecIndividualApiV1SecIndividualsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SECIndividualCreateToJSON(requestParameters['sECIndividualCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Create new SEC individual.
     * Create Sec Individual
     */
    async createSecIndividualApiV1SecIndividualsPost(requestParameters: CreateSecIndividualApiV1SecIndividualsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.createSecIndividualApiV1SecIndividualsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new SEC individual.
     * Create Sec Individual
     */
    async createSecIndividualApiV1SecIndividualsPost_1Raw(requestParameters: CreateSecIndividualApiV1SecIndividualsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['sECIndividualCreate'] == null) {
            throw new runtime.RequiredError(
                'sECIndividualCreate',
                'Required parameter "sECIndividualCreate" was null or undefined when calling createSecIndividualApiV1SecIndividualsPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SECIndividualCreateToJSON(requestParameters['sECIndividualCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Create new SEC individual.
     * Create Sec Individual
     */
    async createSecIndividualApiV1SecIndividualsPost_1(requestParameters: CreateSecIndividualApiV1SecIndividualsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.createSecIndividualApiV1SecIndividualsPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete SEC individual.
     * Delete Sec Individual
     */
    async deleteSecIndividualApiV1SecIndividualsIdDeleteRaw(requestParameters: DeleteSecIndividualApiV1SecIndividualsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSecIndividualApiV1SecIndividualsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Delete SEC individual.
     * Delete Sec Individual
     */
    async deleteSecIndividualApiV1SecIndividualsIdDelete(requestParameters: DeleteSecIndividualApiV1SecIndividualsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.deleteSecIndividualApiV1SecIndividualsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEC individual by ID.
     * Read Sec Individual
     */
    async readSecIndividualApiV1SecIndividualsIdGetRaw(requestParameters: ReadSecIndividualApiV1SecIndividualsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readSecIndividualApiV1SecIndividualsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Get SEC individual by ID.
     * Read Sec Individual
     */
    async readSecIndividualApiV1SecIndividualsIdGet(requestParameters: ReadSecIndividualApiV1SecIndividualsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.readSecIndividualApiV1SecIndividualsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEC individual with their position at a specific date.
     * Read Sec Individual Position
     */
    async readSecIndividualPositionApiV1SecIndividualsIdPositionGetRaw(requestParameters: ReadSecIndividualPositionApiV1SecIndividualsIdPositionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readSecIndividualPositionApiV1SecIndividualsIdPositionGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/{id}/position`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Get SEC individual with their position at a specific date.
     * Read Sec Individual Position
     */
    async readSecIndividualPositionApiV1SecIndividualsIdPositionGet(requestParameters: ReadSecIndividualPositionApiV1SecIndividualsIdPositionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.readSecIndividualPositionApiV1SecIndividualsIdPositionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEC individual with their recent prosecutions.
     * Read Sec Individual Prosecutions
     */
    async readSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGetRaw(requestParameters: ReadSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/{id}/prosecutions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Get SEC individual with their recent prosecutions.
     * Read Sec Individual Prosecutions
     */
    async readSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGet(requestParameters: ReadSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.readSecIndividualProsecutionsApiV1SecIndividualsIdProsecutionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEC individual public data by ID (no authentication required).
     * Read Sec Individual Public
     */
    async readSecIndividualPublicApiV1SecIndividualsPublicIdGetRaw(requestParameters: ReadSecIndividualPublicApiV1SecIndividualsPublicIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividualPublic>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readSecIndividualPublicApiV1SecIndividualsPublicIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/sec-individuals/public/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualPublicFromJSON(jsonValue));
    }

    /**
     * Get SEC individual public data by ID (no authentication required).
     * Read Sec Individual Public
     */
    async readSecIndividualPublicApiV1SecIndividualsPublicIdGet(requestParameters: ReadSecIndividualPublicApiV1SecIndividualsPublicIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividualPublic> {
        const response = await this.readSecIndividualPublicApiV1SecIndividualsPublicIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEC individual public data by ID (no authentication required).
     * Read Sec Individual Public
     */
    async readSecIndividualPublicApiV1SecIndividualsPublicIdGet_2Raw(requestParameters: ReadSecIndividualPublicApiV1SecIndividualsPublicIdGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividualPublic>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readSecIndividualPublicApiV1SecIndividualsPublicIdGet_2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/sec-individuals/public/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualPublicFromJSON(jsonValue));
    }

    /**
     * Get SEC individual public data by ID (no authentication required).
     * Read Sec Individual Public
     */
    async readSecIndividualPublicApiV1SecIndividualsPublicIdGet_2(requestParameters: ReadSecIndividualPublicApiV1SecIndividualsPublicIdGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividualPublic> {
        const response = await this.readSecIndividualPublicApiV1SecIndividualsPublicIdGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve SEC individuals.
     * Read Sec Individuals
     */
    async readSecIndividualsApiV1SecIndividualsGetRaw(requestParameters: ReadSecIndividualsApiV1SecIndividualsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SECIndividual>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SECIndividualFromJSON));
    }

    /**
     * Retrieve SEC individuals.
     * Read Sec Individuals
     */
    async readSecIndividualsApiV1SecIndividualsGet(requestParameters: ReadSecIndividualsApiV1SecIndividualsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SECIndividual>> {
        const response = await this.readSecIndividualsApiV1SecIndividualsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve SEC individuals.
     * Read Sec Individuals
     */
    async readSecIndividualsApiV1SecIndividualsGet_3Raw(requestParameters: ReadSecIndividualsApiV1SecIndividualsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SECIndividual>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SECIndividualFromJSON));
    }

    /**
     * Retrieve SEC individuals.
     * Read Sec Individuals
     */
    async readSecIndividualsApiV1SecIndividualsGet_3(requestParameters: ReadSecIndividualsApiV1SecIndividualsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SECIndividual>> {
        const response = await this.readSecIndividualsApiV1SecIndividualsGet_3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve SEC individuals with limited public data (no authentication required). Designed for public profiles page to encourage sign-ups.
     * Read Sec Individuals Public
     */
    async readSecIndividualsPublicApiV1SecIndividualsPublicGetRaw(requestParameters: ReadSecIndividualsPublicApiV1SecIndividualsPublicGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SECIndividualPublic>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/sec-individuals/public/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SECIndividualPublicFromJSON));
    }

    /**
     * Retrieve SEC individuals with limited public data (no authentication required). Designed for public profiles page to encourage sign-ups.
     * Read Sec Individuals Public
     */
    async readSecIndividualsPublicApiV1SecIndividualsPublicGet(requestParameters: ReadSecIndividualsPublicApiV1SecIndividualsPublicGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SECIndividualPublic>> {
        const response = await this.readSecIndividualsPublicApiV1SecIndividualsPublicGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve SEC individuals with limited public data (no authentication required). Designed for public profiles page to encourage sign-ups.
     * Read Sec Individuals Public
     */
    async readSecIndividualsPublicApiV1SecIndividualsPublicGet_4Raw(requestParameters: ReadSecIndividualsPublicApiV1SecIndividualsPublicGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SECIndividualPublic>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/sec-individuals/public`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SECIndividualPublicFromJSON));
    }

    /**
     * Retrieve SEC individuals with limited public data (no authentication required). Designed for public profiles page to encourage sign-ups.
     * Read Sec Individuals Public
     */
    async readSecIndividualsPublicApiV1SecIndividualsPublicGet_4(requestParameters: ReadSecIndividualsPublicApiV1SecIndividualsPublicGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SECIndividualPublic>> {
        const response = await this.readSecIndividualsPublicApiV1SecIndividualsPublicGet_4Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update SEC individual.
     * Update Sec Individual
     */
    async updateSecIndividualApiV1SecIndividualsIdPutRaw(requestParameters: UpdateSecIndividualApiV1SecIndividualsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SECIndividual>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSecIndividualApiV1SecIndividualsIdPut().'
            );
        }

        if (requestParameters['sECIndividualUpdate'] == null) {
            throw new runtime.RequiredError(
                'sECIndividualUpdate',
                'Required parameter "sECIndividualUpdate" was null or undefined when calling updateSecIndividualApiV1SecIndividualsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/sec-individuals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SECIndividualUpdateToJSON(requestParameters['sECIndividualUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SECIndividualFromJSON(jsonValue));
    }

    /**
     * Update SEC individual.
     * Update Sec Individual
     */
    async updateSecIndividualApiV1SecIndividualsIdPut(requestParameters: UpdateSecIndividualApiV1SecIndividualsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SECIndividual> {
        const response = await this.updateSecIndividualApiV1SecIndividualsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
